/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IVCSApiConfiguration, IVCSApiConfigurationParams } from './ivcs-api-configuration';

import { IVCSConsumerService } from './services/ivcs-consumer.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    IVCSConsumerService,
    IVCSApiConfiguration
  ],
})
export class IVCSModule {
  static forRoot(params: IVCSApiConfigurationParams): ModuleWithProviders<IVCSModule> {
    return {
      ngModule: IVCSModule,
      providers: [
        {
          provide: IVCSApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: IVCSModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('IVCSModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
